"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _PDF = require("../PDF");
var _reactPdf = require("react-pdf");
var _reactstrap = require("reactstrap");
require("react-pdf/dist/esm/Page/AnnotationLayer.css");
var _PDFPresentationThumbnail = require("./PDFPresentationThumbnail.styled");
var _hooks = require("../../hooks");
var _pdf = require("../../utils/pdf");
_reactPdf.pdfjs.GlobalWorkerOptions.workerSrc = (0, _pdf.pdfWorkerFactory)();
var PDFPresentationThumbnail = function PDFPresentationThumbnail(_ref) {
  var pdfSource = _ref.pdfSource;
  var _usePresentationContr = (0, _hooks.usePresentationControl)({}),
    onDocumentLoadSuccess = _usePresentationContr.onDocumentLoadSuccess,
    isDocumentLoaded = _usePresentationContr.isDocumentLoaded;
  return _react["default"].createElement(_react["default"].Fragment, null, _react["default"].createElement(_PDFPresentationThumbnail.PDFPage, {
    "data-testid": "pdf-presentation-thumbnail"
  }, _react["default"].createElement(_PDF.StudioPDFDocument, {
    file: pdfSource,
    onLoadSuccess: onDocumentLoadSuccess,
    loading: _react["default"].createElement(_PDFPresentationThumbnail.LoadingPage, null, _react["default"].createElement(_reactstrap.Spinner, null)),
    noData: _react["default"].createElement(_PDFPresentationThumbnail.EmptyPresentationScreen, {
      "data-testid": "pdf-presentation-thumbnail-empty"
    }),
    error: _react["default"].createElement(_PDFPresentationThumbnail.EmptyPresentationScreen, {
      "data-testid": "pdf-presentation-thumbnail-error"
    })
  }, isDocumentLoaded && _react["default"].createElement(_PDF.StudioPDFPage, {
    pageNumber: 1,
    renderAnnotationLayer: false,
    renderTextLayer: false
  }))));
};
PDFPresentationThumbnail.propTypes = {
  pdfSource: _propTypes["default"].string.isRequired
};
var _default = exports["default"] = PDFPresentationThumbnail;